export default (xs) => (xs.length > 0 ? xs.reduce((s, x) => s + x, 0) / xs.length : 0);
//# sourceMappingURL=avg.mjs.map